module.exports = __webpack_public_path__ + "img/yukiho.9b1b1544.png";